export default __webpack_public_path__ + "static/Gdansk_www_falka-135f4c152ea917e135b52169a286eea1.png";